import React, { createContext, useContext, useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 检查令牌是否过期
  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);
      // 检查是否过期（exp 是 Unix 时间戳）
      return decoded.exp * 1000 < Date.now();
    } catch {
      return true;
    }
  };

  // 清除认证信息
  const clearAuth = () => {
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');

    if (token && userData) {
      // 如果令牌过期，清除认证信息
      if (isTokenExpired(token)) {
        clearAuth();
      } else {
        setUser(JSON.parse(userData));
      }
    }
    setLoading(false);

    // 设置定时检查
    const checkInterval = setInterval(() => {
      const currentToken = localStorage.getItem('token');
      if (currentToken && isTokenExpired(currentToken)) {
        clearAuth();
      }
    }, 60000); // 每分钟检查一次

    // 清理定时器
    return () => clearInterval(checkInterval);
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    clearAuth();
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    // 为子组件提供上下文，这里提供了一组函数
    <AuthContext.Provider value={{ user, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

// 返回上下文
export const useAuth = () => {
  // 使用上下文
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 